import { render, staticRenderFns } from "./CabinTypeSelect.vue?vue&type=template&id=6bc8eaf2"
import script from "./CabinTypeSelect.vue?vue&type=script&lang=js"
export * from "./CabinTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./CabinTypeSelect.vue?vue&type=style&index=0&id=6bc8eaf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports